import React from "react";

import styles from "./style.module.scss";

const PanelItems = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.panelItems}>{children}</div>;
};

export default PanelItems;
